<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav" />
    <div class="content">
      <div class="headerbg">
        <span>人力资源管理实训系统</span>
        <b>HUMAN RESOURCE MANAGEMENT TRAINING SYSTEM</b>
      </div>
      <div class="mainbody">
        <div class="setionbox">
          <p>
            《人力资源管理实训系统》全面模拟了企业人力资源规划、招聘、配置、培训、绩效考核、薪酬管理和劳动关系7个专员的典型职能和实际工作，体现了现代大型企业的人力资源管理部门的工作职能及组织结构，完整的构建了人力资源管理的知识体系。
          </p>
        </div>
        <div class="setionbox">
          <div class="setion">
            <div>
              <div class="imgbox">
                <img
                  style="width: 139px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/ManageMent/img1.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>基础试验</span>
                <p>人力资源工作者素质模型</p>
                <p>传统与现代人力资源管理</p>
                <p>人力资源经理与直线经理</p>
              </div>
            </div>
            <div>
              <div class="imgbox">
                <img
                  style="width: 139px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/ManageMent/img2.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>规划专员</span>
                <p>组织结构设计</p>
                <p>工作分析</p>
                <p>...</p>
              </div>
            </div>
            <div>
              <div class="imgbox">
                <img
                  style="width: 139px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/ManageMent/img3.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>招聘专员</span>
                <p>招聘渠道的选择</p>
                <p>面试流程</p>
                <p>&nbsp;</p>
              </div>
            </div>
            <div>
              <div class="imgbox">
                <img
                  style="width: 139px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/ManageMent/img4.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>配置专员</span>
                <p>人力资源配置</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
              </div>
            </div>

            <!--  -->
          </div>
        </div>

        <div class="setionbox">
           <div class="setion">
            <div>
              <div class="imgbox">
                <img
                  style="width: 122px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/ManageMent/img5.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>培训专员</span>
                <p>培训中各部门分工</p>
                <p>培训需求分析方法选择</p>
                 <p>&nbsp;</p>
                  

              </div>
            </div>
            <div>
              <div class="imgbox">
                <img
                  style="width: 139px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/ManageMent/img6.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>绩效考核专员</span>
                <p>考核绩效管理方案选择</p>
                <p>目标管理步骤</p>
                <p>KPI、360°考核</p>
              </div>
            </div>
            <div>
              <div class="imgbox">
                <img
                  style="width: 139px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/ManageMent/img7.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>薪酬管理专员</span>
                <p>薪酬制度设计方法</p>
                <p>工作岗位评价</p>
                <p>薪酬计算、工资发放</p>
              </div>
            </div>
            <div>
              <div class="imgbox">
                <img
                  style="width: 139px"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/ManageMent/img8.png"
                  alt=""
                />
              </div>
              <div class="underbox">
                <span>劳动关系专员</span>
                <p>劳动合同书条款</p>
                <p>合同变更、解除、组织</p>
                <p>劳动争议处理的程序</p>
              </div>
            </div>

            <!--  -->
          </div>
        </div>
         <div class="setionbox">
           <div class="setion">


            <!--  -->
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'ManagementTraining',
  methods:{
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
    },
  }
}
</script>

<style lang="scss" scoped>
.setionbox:nth-child(odd) {
  background: #f8f8f8;
  .left {
    padding-left: 70px;
  }
}
.left {
  flex: 1;
}
.right {
  flex: 1;
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
}
.headerbg {
  width: 100%;
  height: 580px;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/ManageMent/headerbgi.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    font-size: 42px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  b {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #006cda;
  }
}
.setionbox {
  width: 100%;
  // background-color: red;
  .setion {
    margin: 0 auto;
    width: 1200px;
    padding-top: 80px;
    padding-bottom: 80px;
    // background-color: #f5ff;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      flex: 1;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 330px;
      .imgbox {
        flex: 1;
      }
      .underbox {
        flex: 1;
      }

      span {
        margin-top: 30px;
        margin-bottom: 29px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #1c43bd;
      }
      p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
.mainbody > .setionbox > p {
  padding-top: 30px;
  padding-bottom: 30px;
  width: 1080px;
  margin: 0 auto;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  background: #f8f8f8;
  text-align: center;
  line-height: 1.8;
}
</style>



// WEBPACK FOOTER //
// src/pages/ManagementTraining.vue